// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__Q129J","personal":"Profile_personal__nWZuu","contact":"Profile_contact__pSY0g"};